export enum ContentProvider {
  Peloton = 'peloton',
  VirtualActive = 'virtual_active', // Just Ride
}
